import { IsBoolean, IsDate, IsNumber, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';
import { CostCentreDto } from '../costCentre.dto';

export class ApiInstanceDto extends BaseDto {

  @IsString()
  instanceCode: string;

  @IsString()
  instanceKey: string;
  
  @IsString()
  anydeskId: string;

  @IsString()
  anydeskPassword: string;

  @IsDate()
  lastUpSyncDate: Date;

  @IsDate()
  lastDownSyncDate: Date;

  @IsNumber()
  costCentreId: number;

  @IsBoolean()
  enabled: boolean;

  @IsBoolean()
  downstreamEnabled?: boolean;

  @IsBoolean()
  upstreamEnabled?: boolean;

  costCentre?: CostCentreDto;
}